import { render, staticRenderFns } from "./VendorAdmissionsList.vue?vue&type=template&id=4884e8a6&scoped=true&"
import script from "./VendorAdmissionsList.vue?vue&type=script&lang=js&"
export * from "./VendorAdmissionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884e8a6",
  null
  
)

export default component.exports